import React from 'react';
import classNames from 'classnames';
import Lottie from 'lottie-react';
import { PaddingContainer } from '@components';
import productInsuranceAnimation from '@images/animations/productInsuranceAnimation.json';
import * as styles from './ProductInsurance.module.scss';

export const ProductInsurance: React.FC = () => {
	return (
		<PaddingContainer className={'white-bg'}>
			<div className={styles.productInsuranceContainer}>
				<div className="row no-gutters">
					<div className="col-12 col-xl-6 d-flex align-items-center justify-content-center">
						<Lottie animationData={productInsuranceAnimation} loop={true} />
					</div>
					<div className="col-12 col-xl-6 d-flex align-items-center">
						<p
							className={classNames(styles.productInsurance, 'font-size-small')}
						>
							<p className="font-size-22 font-600 mb-2">
								Your product insurance
							</p>
							We aim to provide the highest quality of services through constant
							monitoring of the development process. Any irregularities found
							are registered in our issue tracking systems. You are provided
							with test reports so that you can keep track of our works at every
							stage of the project.
						</p>
					</div>
				</div>
			</div>
		</PaddingContainer>
	);
};
